import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SubmissionFilters } from '../../models/submission-filters.model';
import { StudySaleSubmissionModel } from '../../models/submission.model';
import * as Actions from './submissions.action';
import * as selectors from './submissions.selector';

@Injectable()
export class SubmissionsFacade {
  isLoading$ = this.store.select(selectors.selectIsLoading);
  submissions$ = this.store.select(selectors.selectSubmissions);
  studySubmissions$ = this.store.select(selectors.selectStudySaleSubmissions);
  filters$ = this.store.select(selectors.selectFilters);

  draftSubmissionCount$ = this.store.select(
    selectors.selectDraftSubmissionCount
  );
  constructor(private store: Store) {}

  loadSubmissions(): void {
    this.store.dispatch(Actions.GetUserSubmissions());
  }

  loadSubmissionByStudyId(studyId: number): void {
    this.store.dispatch(Actions.GetSubmissionsByStudyId({ studyId }));
  }

  setFilters(filters: SubmissionFilters): void {
    this.store.dispatch(Actions.SetFilters({ filters }));
  }

  resetFilters(): void {
    this.store.dispatch(Actions.ResetFilters());
  }

  cancelSubmission(
    saleId: number,
    horseId: number,
    submissionId: number
  ): void {
    this.store.dispatch(
      Actions.CancelSubmissionById({
        saleId,
        horseId,
        submissionId,
      })
    );
  }

  cancelStudySubmission(
    submission: StudySaleSubmissionModel,
    studyId: number
  ): void {
    this.store.dispatch(
      Actions.CancelStudySubmission({
        submission,
        studyId,
      })
    );
  }

  cancelDraftSubmission(saleId: number, horseId: number): void {
    this.store.dispatch(
      Actions.CancelDraftSubmission({
        saleId,
        horseId,
      })
    );
  }
  loadDraftSubmissionCount(): void {
    this.store.dispatch(Actions.GetDraftSubmissionsCount());
  }
}
